<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <div class="mb-3">
          <h1 class="fs-4 fw-bold">Manage LR</h1>
          <button
            class="btn btn-sm ms-2 lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            LR View
          </button>

          <button
            class="btn btn-sm ms-2 lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement/view-tracker"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Tracker View
          </button>
        </div>

        <div>
          <button
            class="btn btn-sm me-2 gap-2 lr-btn"
            mat-raised-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            (click)="exportToExcel()"
          >
            Export
          </button>

          <button
            *ngIf="isAdmin || isSuperSupervisor"
            class="btn btn-sm lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement/view-invoice"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            View Invoice
          </button>

          <button
            [matMenuTriggerFor]="menu"
            class="btn btn-dark btn-sm ms-2"
            matTooltipPosition="left"
            mat-raised-button
          >
            <i class="fa-solid fa-plus"></i>
          </button>

          <mat-menu class="mt-2" #menu="matMenu" xPosition="before">
            <p class="whatdoyou">What do you want to add?</p>
            <button
              class="lrtab"
              [routerLink]="['/superAdmin/lrmanagement/add-lr-module/:id']"
              mat-menu-item
            >
              Add LR
            </button>
            <button
              class="lrtab"
              [routerLink]="['/superAdmin/lrmanagement/add-tracker/:id']"
              mat-menu-item
            >
              Add Tracker
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <!-- Search + table -->
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="filter-flex">
        <!-- Search Input -->
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 d-flex align-items-center h-100"
        >
          <!-- <div class="d-flex gap-3 flex-wrap"> -->
          <div class="form-group accountsinp mb-3 flex-fill">
            <label for="search">Search</label>

            <input
              class="search-box form-control"
              #searchInput
              placeholder="Search LR, Client, Vehicle..."
              type="text"
              (keyup)="filterData(searchInput.value)"
            />
          </div>
          <!-- </div> -->
        </div>
        <!-- Date Filters -->

        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
          <div class="d-flex gap-3 flex-wrap">
            <!-- From Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="fromDate">From Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="fromDate"
                (change)="onDateChange($event, 'from')"
              />
            </div>

            <!-- To Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="toDate">To Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="toDate"
                (change)="onDateChange($event, 'to')"
              />
            </div>
          </div>
        </div>

        <!-- Clear Filters Button -->
        <div class="col-sm-1 d-flex align-items-center h-100">
          <button
            class="clearFilterBtn"
            mat-raised-button
            (click)="clearFilters()"
          >
            <img src="/assets/images/svg/ClearFilter.svg" alt="clear" />
          </button>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortActive="date"
          matSortDirection="desc"
          (matSortChange)="sortData($event)"
          class="row-border hover tablelist"
        >
          <!-- Manual LR -->
          <ng-container matColumnDef="manualLR_no">
            <th mat-header-cell *matHeaderCellDef>Manual LR No.</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.manualLR_no }}
            </td>
          </ng-container>

          <!-- LR No -->
          <ng-container matColumnDef="LR_no">
            <th mat-header-cell *matHeaderCellDef>System LR No.</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.LR_no }}
            </td>
          </ng-container>

          <!-- Created by -->
          <ng-container matColumnDef="created_by">
            <th mat-header-cell *matHeaderCellDef>Created by</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.created_by?.full_name }}
            </td>
          </ng-container>

          <!-- Client Name -->
          <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Company Name
            </th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.clientName }}
            </td>
          </ng-container>

          <!-- Vehicle -->
          <ng-container matColumnDef="vehicle_id">
            <th mat-header-cell *matHeaderCellDef>Vehicle No.</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.vehicle_id }}
            </td>
          </ng-container>

          <!-- Consignee -->
          <ng-container matColumnDef="consignee_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Consignee</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.consignee_name }}
            </td>
          </ng-container>

          <!-- Consignor -->
          <ng-container matColumnDef="consignor_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Consignor</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.consignor_name }}
            </td>
          </ng-container>

          <!-- Date -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.date | date : "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <!-- From -->
          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.from }}
            </td>
          </ng-container>

          <!-- To -->
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
            >
              {{ receipt.to }}
            </td>
          </ng-container>

          <!-- Vehicle Rate -->
          <ng-container matColumnDef="vehicle_rate">
            <th mat-header-cell *matHeaderCellDef>Vehicle Rate</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
              class="text-center"
            >
              {{ receipt.vehicleRate }}
            </td>
          </ng-container>

          <!-- Advance -->
          <ng-container matColumnDef="advance">
            <th mat-header-cell *matHeaderCellDef>Advance</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
              class="text-center"
            >
              {{ receipt.advance }}
            </td>
          </ng-container>

          <!-- Total Expense -->
          <ng-container matColumnDef="total_expense">
            <th mat-header-cell *matHeaderCellDef>Total Expense</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
              class="text-center"
            >
              <!-- {{ receipt.total_expense }} -->
              {{ receipt.totalExpense }}

            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Action
            </th>
            <td mat-cell *matCellDef="let receipt" class="text-center">
              <div class="d-flex justify-content-center gap-3">
                <button
                  [routerLink]="[
                    '/superAdmin/lrmanagement/detail-lr',
                    receipt._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="View"
                >
                  <i class="fas fa-eye"></i>
                </button>

                <button
                  *ngIf="isAdmin || isSuperSupervisor"
                  [routerLink]="[
                    '/superAdmin/lrmanagement/edit-lr',
                    receipt._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="Edit"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>

                <button
                  [routerLink]="[
                    '/superAdmin/lrmanagement/view-lr',
                    receipt._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="Print"
                >
                  <i class="fas fa-print"></i>
                </button>

                <button
                  *ngIf="isAdmin"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="Delete"
                  (click)="deleteLR(receipt)"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </ng-container>

          <!-- Table Header + Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <!-- Paginator -->
      <mat-paginator
        [length]="totalRecords"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Spinner -->
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
